import { defineComponent as _defineComponent } from 'vue'
import {
  useI18n,
} from "@/composables/useI18n";

import {
  PropType,
  ref,
  unref,
  watch,
} from "vue";

import {
  PaymentDetails,
} from "@/model/PaymentDetails";

import {
  PaymentMethod,
} from "@/Enums";

import {
  isValidDate,
} from "@/scripts/Validations/Validations";

import {
  hasSepaConditionForId,
  hasValidLengthOnSepaCondition,
  isValidEmail,
} from "@/scripts/Common/validators";

import {
  countCharacterSepaField,
  getInvalidCharacters,
} from "@/scripts/Common/helpers";

import {
  SEPA_CHARACTER_REPLACER_REGEX_ID,
} from "@/scripts/Constants";

import {
  MAX_MANDATE_REFERENCE_LENGTH,
  MAX_INVOICE_EMAIL_LENGTH
} from "@/components/children/PaymentDetails/scripts";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentDetails',
  props: {
  paymentDetails: {
    required: true,
    type: Object as PropType<PaymentDetails>
  },
  hasNoEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  expanded: {
    required: false,
    type: Array as PropType<Array<number>>,
    default() {
      return [1]
    }
  },
},
  emits: [
  'onValidChange',
  'onModelChange',
],
  setup(__props, { emit: emits }) {

const props = __props;


const {
  t,
} = useI18n();





const valid = ref(true);
const paymentDetailsForm = ref();
const internalExpand = ref(props.expanded);

const validate = async () => {
  paymentDetailsForm.value?.validate();
}

const paymentMethodSelection = [
  {method: t('payment_method_invoice'), value: PaymentMethod.invoice},
  {method: t('payment_method_base_debit'), value: PaymentMethod.baseDebit},
  {method: t('payment_method_company_debit'), value: PaymentMethod.companyDebit},
];

watch(() => valid.value, () => {
  emits('onValidChange', unref(valid));
});

watch(() => props.expanded, () => {
  internalExpand.value = props.expanded;
})

watch(() => props.paymentDetails, () => validate(), {deep: true})


return { __sfc: true,t, emits, props, valid, paymentDetailsForm, internalExpand, validate, paymentMethodSelection, isValidDate, hasSepaConditionForId, hasValidLengthOnSepaCondition, isValidEmail, countCharacterSepaField, getInvalidCharacters, SEPA_CHARACTER_REPLACER_REGEX_ID, MAX_MANDATE_REFERENCE_LENGTH, MAX_INVOICE_EMAIL_LENGTH }
}

})